'use strict';

var _classCallCheck = require("/home/lana/NOZ/admin/noz-admin-cliente/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _possibleConstructorReturn = require("/home/lana/NOZ/admin/noz-admin-cliente/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/lana/NOZ/admin/noz-admin-cliente/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/lana/NOZ/admin/noz-admin-cliente/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/home/lana/NOZ/admin/noz-admin-cliente/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
var pump = require('pump');
var bufferStream = require('./buffer-stream');
var MaxBufferError = /*#__PURE__*/function (_Error) {
  _inherits(MaxBufferError, _Error);
  function MaxBufferError() {
    var _this;
    _classCallCheck(this, MaxBufferError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MaxBufferError).call(this, 'maxBuffer exceeded'));
    _this.name = 'MaxBufferError';
    return _this;
  }
  return MaxBufferError;
}(_wrapNativeSuper(Error));
function getStream(inputStream, options) {
  if (!inputStream) {
    return Promise.reject(new Error('Expected a stream'));
  }
  options = Object.assign({
    maxBuffer: Infinity
  }, options);
  var _options = options,
    maxBuffer = _options.maxBuffer;
  var stream;
  return new Promise(function (resolve, reject) {
    var rejectPromise = function rejectPromise(error) {
      if (error) {
        // A null check
        error.bufferedData = stream.getBufferedValue();
      }
      reject(error);
    };
    stream = pump(inputStream, bufferStream(options), function (error) {
      if (error) {
        rejectPromise(error);
        return;
      }
      resolve();
    });
    stream.on('data', function () {
      if (stream.getBufferedLength() > maxBuffer) {
        rejectPromise(new MaxBufferError());
      }
    });
  }).then(function () {
    return stream.getBufferedValue();
  });
}
module.exports = getStream;
module.exports.buffer = function (stream, options) {
  return getStream(stream, Object.assign({}, options, {
    encoding: 'buffer'
  }));
};
module.exports.array = function (stream, options) {
  return getStream(stream, Object.assign({}, options, {
    array: true
  }));
};
module.exports.MaxBufferError = MaxBufferError;